export const domain = process.env.REACT_APP_BASE_URL
// export const domain = process.env.REACT_APP_BASE_URL_TEST;
